import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 8,
  steps: [
    addColumns({
      table: 'messages',
      columns: [{ name: 'header_media_url', type: 'string', isOptional: true }]
    })
  ]
}
